export default "__VITE_ASSET__CiltM5UD__"